import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useLocation, useSearchParams} from 'react-router-dom'
import {useQuery} from 'react-query'
import {getTaskTemplateById} from '../core/_requests'
import {Loading} from '../../../../_metronic/partials/components/loading/Loading'
import { TaskTemplateEditModal } from './TaskTemplateEditModal'
import { ID } from '../../../../_metronic/helpers'

type Props = {}

export const TaskTemplateEditModalWrapper: FC<Props> = ({}) => {
  const location = useLocation()
  const {pathname} = location
  const [searchParams, setSearchParams] = useSearchParams()
  const taskTemplateId = searchParams.get('taskTemplateId') as ID

  const {
    isLoading,
    data: task,
    error,
  } = useQuery(
    `get-task-template-by-id-${taskTemplateId}`,
    () => {
      return getTaskTemplateById(taskTemplateId)
    },
    {
      enabled: !!taskTemplateId,
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      onSuccess: (data) => !data && window.location.assign(pathname),
    //   onError: () => (window.location.pathname = '/error/404'),
      retry: true,
    }
  )

  function handleClose() {
    let newParams = new URLSearchParams(searchParams)
    newParams.delete('taskTemplateId')
    setSearchParams(newParams)
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Modal
      className='modal'
      id='kt_modal_edit_task_template'
      tabIndex={-1}
      dialogClassName='modal-dialog mw-1000px modal-dialog-centered'
      show={(taskTemplateId) ? true : false}
      backdrop='static'
      onHide={handleClose}
      enforceFocus={false}
      autoFocus={false}
    >
      <TaskTemplateEditModal isTaskLoading={isLoading} handleClose={handleClose} task={task!} />
    </Modal>
  )
}